import { IRollSelectBehaviorSpecifiable, instanceOfIRollSelectBehaviorSpecifiable } from "../../../../documaker/domain/format/objects";
import { ISelectableObject, instanceOfISelectableObject } from "./ISelectableObject";

export interface IRollObject extends ISelectableObject, IRollSelectBehaviorSpecifiable {
}

export function instanceOfIRollObject(instance: any): instance is IRollObject {
  return instance
      && instanceOfIRollSelectBehaviorSpecifiable(instance)
      && instanceOfISelectableObject<IRollObject>(instance, "roll");
}
